import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: [],
  totalRecords: 0,
  totalPages: 0,
  detail: null,
  summary: null,
  isListLoading: true,
  isDetailLoading: false,
  isSummaryLoading: true,
  isExporting: false,
  listError: '',
};

const paymentFailedOrdersSlice = createSlice({
  name: 'PaymentFailedOrders',
  initialState,
  reducers: {
    setListLoading(state, action) {
      state.isListLoading = action.payload;
    },
    setPaymentFailedOrders(state, action) {
      const payload = action.payload || {};
      const data = payload.data || {};
      // The API answers with { data: [rows], pagination: { total, total_pages } }
      const pagination = payload.pagination || data.pagination || {};
      state.list = Array.isArray(data)
        ? data
        : data.data || data.rows || data.orders || data.list || [];
      state.totalRecords = Number(
        pagination.total ??
          data.recordsTotal ??
          data.total_records ??
          data.totalRecords ??
          data.total ??
          payload.recordsTotal ??
          0,
      );
      state.totalPages = Number(
        pagination.total_pages ?? pagination.totalPages ?? 0,
      );
      state.isListLoading = false;
      state.listError = '';
    },
    setListError(state, action) {
      state.list = [];
      state.totalRecords = 0;
      state.totalPages = 0;
      state.isListLoading = false;
      state.listError = action.payload || 'Failed to load payment failed orders.';
    },
    setDetailLoading(state, action) {
      state.isDetailLoading = action.payload;
    },
    setPaymentFailedOrderDetail(state, action) {
      state.detail = action.payload?.data || null;
      state.isDetailLoading = false;
    },
    clearPaymentFailedOrderDetail(state) {
      state.detail = null;
      state.isDetailLoading = false;
    },
    setSummaryLoading(state, action) {
      state.isSummaryLoading = action.payload;
    },
    setPaymentFailedOrdersSummary(state, action) {
      const data = action.payload?.data || {};
      // The API returns { summary: { total_failed_orders, ... } } - normalise it
      // to the field names the KPI tiles use
      const figures = data.summary || data;
      state.summary = {
        total: Number(figures.total_failed_orders ?? figures.total ?? 0),
        converted: Number(figures.converted_count ?? figures.converted ?? 0),
        not_converted: Number(
          figures.not_converted_count ?? figures.not_converted ?? 0,
        ),
        open: Number(figures.still_open_count ?? figures.open ?? 0),
        conversion_rate: Number(
          figures.conversion_rate_pct ?? figures.conversion_rate ?? 0,
        ),
        revenue_recovered: Number(figures.revenue_recovered ?? 0),
        currency: figures.currency || '',
        attended: figures.attended || null,
        not_attended: figures.not_attended || null,
        // daily series for the trend chart, passed through untouched
        daily: data.daily || data.trend || figures.daily || figures.trend || [],
      };
      state.isSummaryLoading = false;
    },
    setExporting(state, action) {
      state.isExporting = action.payload;
    },
  },
});

export const {
  setListLoading,
  setPaymentFailedOrders,
  setListError,
  setDetailLoading,
  setPaymentFailedOrderDetail,
  clearPaymentFailedOrderDetail,
  setSummaryLoading,
  setPaymentFailedOrdersSummary,
  setExporting,
} = paymentFailedOrdersSlice.actions;

const paymentFailedOrdersReducer = paymentFailedOrdersSlice.reducer;

export default paymentFailedOrdersReducer;
